import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pay-confirmation',
  templateUrl: './pay-confirmation.component.html',
  styleUrls: ['./pay-confirmation.component.css']
})
export class PayConfirmationComponent implements OnInit {

  pageInformations: any;
  headerData: any;
  siteInformations: any;
  breadcrumbCaptions: any;
  loader: boolean;
  customerName: string = 'Login';
  customerProfile: string = 'assets/img/user_profile.png';
  viewTicketButton:boolean;
  service_fee: any;

  constructor() {
    this.loader = true;
    this.viewTicketButton = true;
  }

  ngOnInit() {

    // Access footer ID and append script 
    let footerElement = document.getElementById('confirmationFooterID') as HTMLElement;
    let siteInfo = sessionStorage.getItem('siteInformations') ? JSON.parse(sessionStorage.getItem('siteInformations')) : "";

    if (siteInfo != "" && siteInfo != undefined) {
      let globalFooter = siteInfo.data.global_footer_html;
      let removeDoctype = globalFooter.replace('<!DOCTYPE html>', '').replace('</html>', '').trim();
      footerElement.innerHTML = removeDoctype;
    }

    if (sessionStorage['pageinformationData']) {
      this.pageInformations = JSON.parse(sessionStorage.getItem('pageinformationData'));

      if (this.pageInformations.data) {
        if (this.pageInformations.data.header) {
          this.headerData = this.pageInformations.data.header;
        }

        if (this.pageInformations.data.body) {
          document.body.style.backgroundColor = this.pageInformations.data.body.background_color;
        }
        this.loader = false;
      }

      if (sessionStorage['breadcrumbInfo']) {
        this.breadcrumbCaptions = JSON.parse(sessionStorage.getItem('breadcrumbInfo'));
      }
      // this.pageInformations = JSON.parse(sessionStorage.getItem('pageinformationData'));
      console.log('pageInfoData----str-----:' + JSON.stringify(this.pageInformations));

    } else {
      // alert('No session data');
    }

    if (sessionStorage['siteInformations']) {
      this.siteInformations = JSON.parse(sessionStorage['siteInformations']);
      console.log('siteInformations---payment- str-:', this.siteInformations);
      const backgroundStyle = this.siteInformations.data.background_style;
      document.body.style.backgroundImage = 'url(' + backgroundStyle + ')';
    }

    let customerInfo = sessionStorage.customerInfo ? JSON.parse(sessionStorage.customerInfo) : null;
    if (customerInfo) {
      this.customerName = customerInfo.name || customerInfo.last_name ? `${customerInfo.first_name} ${customerInfo.last_name}` : 'Login';
      this.customerProfile = customerInfo.image ? customerInfo.image : 'assets/img/user_profile.png';
    }
    // hide view ticket button
    let viewTicketHide = sessionStorage.completeSale ? JSON.parse(sessionStorage.completeSale) : null;
    if(viewTicketHide){
      if((viewTicketHide.data.has_debit != undefined && viewTicketHide.data.has_ticket != undefined) && (viewTicketHide.data.has_debit == false && viewTicketHide.data.has_ticket == false)){
        this.viewTicketButton = false;
      }else{
        this.viewTicketButton = true;
      }
    }
  }

  toToViewTicketUrl() {
    if (sessionStorage['viewTicketUrl']) {
      const viewTicketUrl = sessionStorage['viewTicketUrl'];
      window.open(viewTicketUrl);
    }
  }

}
